export { default } from './PrimaryLink';